import { useState } from 'react'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'

const VerticalPagination = props => {
    const { pageIndex, setPageIndex, pageCount, conditionFnToChangePage } = props
    const [pageNumber, setPageNumber] = useState(pageIndex + 1)
    
    const changePage = newPageIndex => {
        if (newPageIndex < 0 || newPageIndex >= pageCount) return
        
        if (conditionFnToChangePage()) {
            if (!confirm('Are you sure you want to leave? You have unsaved changes.')) return
        }
        
        setPageIndex(newPageIndex)
        setPageNumber(newPageIndex + 1)
    }
    
    return (
        <div className="flex flex-col items-center gap-3">
            <div
                className="pt-2 cursor-pointer"
                onClick={() => changePage(pageIndex - 1)}>
                <MdArrowUpward className="text-lg"/>
            </div>
            <div>
                <input
                    type="text"
                    className="bg-base-100 rounded-md w-8 h-8 text-center text-sm p-0"
                    value={pageNumber}
                    onKeyUp={e => {
                        if (e.key === 'Enter') {
                            if (e.target.value > 0 && e.target.value <= pageCount) {
                                changePage(pageNumber - 1)
                            } else {
                                setPageNumber(pageIndex + 1)
                            }
                        }
                    }}
                    onChange={e => {
                        setPageNumber(e.target.value)
                    }}/>
            </div>
            <div>{pageCount}</div>
            <div
                className="pb-2 cursor-pointer"
                onClick={() => changePage(pageIndex + 1)}>
                <MdArrowDownward className="text-lg" />
            </div>
        </div>
    )
}

export default VerticalPagination
